export class SiteDetailsDialog {

    siteId: number;
    token: string;

    successCallback: (response) => void;

    constructor(siteId: number) {
        this.siteId = siteId;
        this.token = document.querySelector('input[name="__RequestVerificationToken"]').getAttribute('value');

        this.initialize();
    }

    initialize() {
        $('#editSiteDialog .ctms-button-save').on('click', this.saveDialog.bind(this));

        $('#editSiteDialog').on('hidden.bs.modal', (e) => {
            const f = document.getElementById('siteDialogForm') as HTMLFormElement;
            f.reset();
        });
    }

    async resetDialog() {
        const response = await fetch(
            `/secure/ctms/sites/site-details?handler=SiteDetailsDialog&id=${this.siteId}`,
            {
                method: 'GET',
                headers: { "RequestVerificationToken": this.token },
            }
        );
        if (!response.ok) {
            throw new Error(response.statusText);
        }
        const result = await response.text();
        document.querySelector('#editSiteDialogBody').innerHTML = result;

        const cityDropdown = $('#city-dropdown');

        const currentValue = (cityDropdown.data('current')?.toString() || '').trim();
        
        cityDropdown.empty();
        if (currentValue.length > 0) {
            cityDropdown.append(`<option value="${currentValue}" selected>${currentValue}</option>`);
        }

        cityDropdown.selectpicker('refresh');

        $(document).off('keyup.citysearch');

        $(document).on('keyup.citysearch', '.bs-searchbox input', async (event) => {

            const userInput = $(event.currentTarget).val()?.toString() || '';

            if (userInput.length < 2) {
                return;
            }

            try {
                const cityResponse = await fetch(
                    `/secure/ctms/sites/site-details?handler=CityStates&startsWith=${encodeURIComponent(userInput)}`,
                    {
                        method: 'GET'
                    }
                );

                if (!cityResponse.ok) throw new Error(cityResponse.statusText);

                const cityData = await cityResponse.json();

                cityDropdown.empty();

                cityData.forEach(item => {
                    const value = item.text; // you are storing "City, ST"
                    const selected = value === currentValue ? 'selected' : '';
                    cityDropdown.append(`<option value="${value}" ${selected}>${item.text}</option>`);
                });

                cityDropdown.selectpicker('refresh');

            } catch (err) {
                console.error('Failed to load city/state data', err);
            }
        });


    }

    saveDialog(evt: JQuery.ClickEvent) {
        const f = document.getElementById('siteDialogForm') as HTMLFormElement;

        if (f.checkValidity()) {

            $('#siteDialogForm').removeClass('ctms-invalid-form');
            $.ajax({
                url: `/secure/ctms/sites/site-details?handler=UpdateSiteDetails&id=${this.siteId}`,
                headers: { "RequestVerificationToken": this.token },
                type: 'POST',
                data: $('#editSiteDialog .ctms-field-submit').serialize(),
                success: (resp) => {
                    // Update site name if it changed
                    if (this.successCallback) this.successCallback(resp);
                    $('#editSiteDialog').modal('hide');
                }
            });
        } else {
            $('#siteDialogForm').addClass('ctms-invalid-form');
        }

        evt.preventDefault();
        evt.stopPropagation();
    }
}